"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderReviseAlteration = void 0;
const models_1 = require("../../common/models");
const enums_1 = require("../enums");
class SalesOrderReviseAlteration extends models_1.MongoSubDocument {
    hasChanges() {
        return (this.productId !== undefined ||
            this.productCode !== undefined ||
            this.productRevision !== undefined ||
            this.productDescription !== undefined ||
            this.quantity !== undefined ||
            this.price !== undefined ||
            this.dueDate !== undefined ||
            this.shipDate !== undefined);
    }
}
exports.SalesOrderReviseAlteration = SalesOrderReviseAlteration;
//# sourceMappingURL=sales-order-revise-alteration.model.js.map